import { MailOutlined } from '@ant-design/icons';
import {
  CustomWarningsRule,
  Datatype,
  IWidgetType,
  RequiredRule,
  WidgetCategory,
  WidgetMainType,
  getSimpleWidgetReference,
  tran,
} from '@framework/engine';
import { EmailVerificationWidgetComponent } from './EmailVerificationWidgetComponent';
import { EmailVerificationWidgetConfigComponent } from './EmailVerificationWidgetConfigComponent';
import { EmailVerificationWidgetConfigSchema } from './EmailVerificationWidgetConfigSchema';
import {
  IEmailVerificationWidget,
  WidgetEmailVerificationType,
} from './IEmailVerificationWidget';
import {
  EmailVerificationWidgetRule,
  createEmailVerificationWidgetFormSchema,
} from './createEmailVerificationWidgetFormSchema';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    EmailVerification = 'emailVerification',
  }
}

/**
 * Widget per i,inserimento e verifica dell'email
 */
export const EmailVerificationWidgetType: IWidgetType<IEmailVerificationWidget> =
  {
    type: WidgetEmailVerificationType,
    mainType: WidgetMainType.Input,
    category: WidgetCategory.Advanced,
    name: 'Verifica Email',
    icon: <MailOutlined />,
    hasValue: true,
    getReference: getSimpleWidgetReference(Datatype.String),
    // getSiblingReferences: () => [],
    formComponent: EmailVerificationWidgetComponent,
    previewComponent: EmailVerificationWidgetComponent,
    createFormSchema: createEmailVerificationWidgetFormSchema,
    configValidator: EmailVerificationWidgetConfigSchema,
    configComponent: EmailVerificationWidgetConfigComponent,
    configOptions: {},
    // Traduzioni
    translationSchema: tran.widget({
      label: tran.rte(),
      helpText: tran.rte(),
      placeholder: tran.string(),
      rules: tran.rules(),
      layout: tran.object({
        startButtonText: tran.string(),
        startHelpText: tran.rte(),
        endButtonText: tran.string(),
        endHelpText: tran.rte(),
      }),
    }),
    rules: [RequiredRule, CustomWarningsRule],
    fixedRules: [EmailVerificationWidgetRule],
  };
